import{styled as i}from"styled-components";const t=i.input`
  height: 19px;
  line-height: 22px;
  margin: 0 5px 0 0.5px;
  vertical-align: middle;
`;export{t as BaseRadio};
